import { createStore } from 'zustand-x';

export const useRemovePaddingStore = createStore('removePadding')({
  removePadding: false,
}).extendActions((set) => ({
  removePaddingLeftAndRight: () => {
    set.removePadding(true);
  },
  setPaddingLeftAndRight: () => {
    set.removePadding(false);
  },
}));
